import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import Popup from "../sharedComponents/Popup";
import RegisterLocalSection from "../sharedComponents/RegisterLocalSection";
import RegisterForeignSection from "../sharedComponents/RegisterForeignSection";
function Register() {
  const [loginImg, setLoginImg] = useState("");
  // popup
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const location = useLocation();
  console.log("location", "location");
  //圖片
  useEffect(() => {
    axios
      .get("/api/Home/StoreData")
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return null;
        }
      })
      .then((data) => {
        if (data) {
          setLoginImg(data.loginImage);
          console.log("contactImg", "data");
        }
      })
      .catch((error) => {
        console.error("Error fetching data from API:", "error");
      });
  }, []);

  // 根据路由路径决定按钮和登录区域
  let registerButton = null;
  let registerSection = null;

  if (location.pathname === "/foreignregister") {
    registerButton = (
      <>
        <Link to="/register" className="btn news-cate-btn">
          國內會員註冊
        </Link>
        <div className="btn news-cate-btn selected">國外會員註冊</div>
      </>
    );
    registerSection = <RegisterForeignSection />;
  } else if (location.pathname === "/register") {
    registerButton = (
      <>
        <div className="btn news-cate-btn selected">國內會員註冊</div>
        <Link to="/foreignregister" className="btn news-cate-btn ">
          國外會員註冊
        </Link>
      </>
    );
    registerSection = <RegisterLocalSection />;
  }
  return (
    <>
      <div className="container px-0">
        <div className="login-detail">
          <div className="container login-img-container">
            <div className="d-xxl-sticky pb-3">
              <div className="login-img">
                <img src={loginImg} className="w-100" alt="" />
              </div>
            </div>
          </div>
          <div className="container login-content">
            <div className="container px-0">
              <div className="news-cate pt-0"> {registerButton}</div>
            </div>
            {registerSection}
          </div>
        </div>
      </div>
    </>
  );
}

export default Register;
